export default {
  header: {
    dark: "Dark theme",
    light: "Light theme",
    system: "System theme",
    environment: "You work on the test environment",
    notification: {
      label: "Processing notifications",
      status_processing: "Processing in progress",
      status_success: "Processing complete, your file is ready",
      status_error: "Processing failed",
      status_unknown:
        "Tracking interrupted: the process may still be running on the server, but your browser can no longer confirm it.",
      status_announcement: "{label}: {status}",
      empty: "No processing in progress...",
      waiting: "Waiting for information on processing",
      list: "View full history",
      load_more: "Show more",
      historic: "Processing history",
      download: "Download",
      file: "Your file",
    },
  },
  menu: "Menu",
  dashboard: {
    presentation: "Presentation",
    contact: "Contact",
    partner: "Partners",
    communication: "Communication",
    timeline: "Timeline",
    timeline_actions: {
      delete: {
        confirmation: "Are you sure you want to delete this row?",
        success: "Row deleted successfully!",
      },
    },
    indicator: "Indicators",
    indicators: {
      see_details: "View completion rates in detail",
      see_details_complete_triad: "Complete three-party group rate",
      fill_rate: "Completion rates",
    },
    shared_docs: "Shared documents",
    registration: "Registrations",
    registration_apprentice: "Registration area (apprentice)",
    welcome_to_studea: "Welcome to your Studea portal!",
    welcome_to_dashboard: "Welcome to your dashboard",
    your_actually_are: "You are currently",
    // ST143-TI-17771 (b2): plain placeholder, no embedded HTML — the <strong> wrapping is done by <i18n-t>'s
    // "name" slot in HeaderComponent.vue, as real DOM markup, not by string concatenation.
    welcome_message: "Welcome to your Studea portal, {name}!",
    no_training_course_archived: "No year group archived",
    no_training_course_actived: "No active year group",
    no_triad: "No three-party group",
    triad_search_placeholder: "Search",
    triad_members: "Members of the trinomial",
    questionnaires_empty: "No questionnaire to complete",
    weather_solicitation: {
      apprentice_title: "How are things going at the company right now?",
      apprentice_master_title: "How would you rate your apprentice's situation?",
      about_apprentice: "Regarding {name}",
      success: "Thank you, your feedback has been recorded!",
      visibility_notice: "Visible to the CFA's teaching team",
    },
    contract: {
      company_sheet: "InseeCompany profile",
      type: "Type of contract :",
      company: "Employer:",
      dates: "Contract dates:",
      rupture_date: "Date of termination",
      rupture_cause: "Reason for termination",
      siret: "Siret:",
      address: "Address :",
      from: "From",
      to: "to",
      by: "by",
      secondary: "secondary",
      reference_contract: "Reference contract",
      vised_cerfa: "CERFA accredited",
      mission_file: "Mission statement",
      rupture_justificative: "Justification file",
      rupture_invalidtion_confirmation: "Are you sure you want to cancel the validation of this breach of contract?",
      rupture_declared: "Breach declared on",
      rupture_validated: "Validate the breach",
      rupture_invalidate: "Invalidate the breach",
      invalidate: "Invalidate",
      date_overlaps:
        "Some contract dates overlap. Please record the termination of the previous contract or check the dates entered in the contracts.",
      no_active_contract_mission: "No contract is present on this triad. Please add one in order to add missions.",
      no_active_contract_activity: "No contract is present on this triad. Please add one in order to add activities.",
    },
    training: {
      triad_list: "View the list of triads",
    },
    archived_training_course: ({ plural, named }) =>
      plural([`View archived ${named("label")}s`, `View archived ${named("label")}s`]),
    unarchived_training_course: ({ plural, named }) =>
      plural([`View active ${named("label")}s`, `View active ${named("label")}s`]),
    Download_the_booklet: "Download digital booklet",
    Download_the_booklet_with_documents: "Download the booklet with these documents",
    Download_key_dates: "Download key dates",
    session_lock: "This session is not yet available for input.",
    skill_lock:
      "You cannot change \nthis skill, which is \ncalculated using your responses to the \nquestionnaires or which is not \nallocated to you.",
    driverLicence: {
      config: "Gestion des aides permis B",
      confirmation_send: "Le pilote rattaché à votre dossier a été notifié de votre demande.",
      progress: {
        paymentDate: "Date de paiement",
        requestDate: "Date de la demande",
        transmissionDate: "Date de transmission au service financier",
        validationDate: "Date de validation",
      },
    },
    skill: {
      rate_by_profil: "Skill fulfilment rate by profile",
    },
  },
  driver_licence: {
    info: "Your file will be sent once all attachments have been submitted.",
    triad_list: "View triad list",
  },
};
